<div
  [class.active]="active$ | async"
  class="backdrop"
></div>
<div
  [class.active]="active$ | async"
  class="loading-screen"
>
  <div class="loading-content">
    <div class="w-full flex justify-center items-center">
      <bnd-loading [size]="'lg'" />
    </div>

    <p class="mt-4">
      {{ 'LOADING.DEFAULT' | translate }}
    </p>
  </div>
</div>
